var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "container-fluid my-2" }, [
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          { staticClass: "panel-body" },
          [
            _c("MultiSelectionPicker", {
              attrs: {
                "all-items": _vm.availables,
                "allow-item-list-editing": !_vm.readOnly,
                "column-count": 1,
                "item-type-name": "Necesidad",
                maxlength: "500",
                "modify-removes-item": true,
                "selected-items": _vm.selectedItems
              },
              on: {
                itemAdded: _vm.addNewNeed,
                itemDeleted: _vm.deletedNeed,
                itemModified: _vm.editNeed
              }
            }),
            _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("Error", {
                    attrs: {
                      "is-alert-mode": "",
                      message:
                        "Puede seleccionar una(1) o más necesidades. Selección múltiple."
                    }
                  })
                ],
                1
              )
            ]),
            _c("CustomChipsGroup", {
              attrs: {
                disabled: _vm.readOnly,
                "no-wrap": true,
                "object-text": "name",
                "selected-items": _vm.selectedItems,
                title: "Necesidades Seleccionadas"
              },
              on: { itemMarkedForDeletion: _vm.removeSelection }
            })
          ],
          1
        )
      ])
    ]),
    _c(
      "div",
      { staticClass: "actions" },
      [
        !_vm.readOnly
          ? _c(
              "ActionButton",
              {
                attrs: { i: "fas fa-save", variant: "success m-2" },
                on: { click: _vm.save }
              },
              [_vm._v(" Guardar ")]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }